import React from 'react'
import ReadMoreButton from '../../../read-more-button'
import { YoutubeMonitor } from '../../../youtube-monitor'

export const AboutSection = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row content">
          <div className="col-lg-6">
            <h2>Financial application suited for dairy business.</h2>

            <h3>
              Producer Payrolls
              <br />
              Milk Laboratory Integration
              <br />
              Milk Hauler and Manifesting
            </h3>

            <ReadMoreButton url="/docs/posts/getting-started-with-payroll" />
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <YoutubeMonitor youtubeId="MXugxHkb_JA" />
          </div>
        </div>
      </div>
    </section>
  )
}
